const UPLOAD_CONFIG = {
  MAX_UPLOAD: 5000,
  SIZE: 8388608,
  SUPPORTED_FORMATS: {
    CSV: {label: 'CSV', value: 'text/csv'},
    PDF: {label: 'PDF', value: 'application/pdf'},
    XLSX: {
      label: 'XLSX',
      value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    XLS: {label: 'XLS', value: 'application/vnd.ms-excel'},
    PNG: {label: 'PNG', value: 'image/png'},
    JPG: {label: 'JPG', value: 'image/jpg'},
    JPEG: {label: 'JPEG', value: 'image/jpeg'},
  },
}

const STATUS_ADD_TO_A1_BATCH = {
  ACTIVE_BOX: {
    SMART: 'smart',
    CREATE: 'create',
    EXISTING: 'existing',
  },
  ACTION: {
    CREATE: 'create',
    EXCLUDE: 'exclude',
    MOVE: 'move',
  },
}

const A1_BATCH_STATUS = {
  OPEN: 'open',
  PROCESSED: 'processed',
  ARCHIVED: 'archived',
}

const OPTIONS_JOURNEY_INFO = {
  INCOMPLETE: {label: 'INCOMPLETE', value: 'incomplete'},
  COMPLETE: {label: 'COMPLETE', value: 'complete'},
}
const OPTIONS_JOURNEY_STATUS = {
  N_A: {label: 'N_A', value: [null], color: '#FF7272'},
  READY: {label: 'READY', value: ['ready'], color: '#FFE310'},
  PICK_UP_DROP_OFF: {
    label: 'PICK_UP_DROP_OFF',
    value: ['pickup_dropoff', 'picked_up', 'air_delivery'], // Value 1 is Status Primary, Value 2 is Status Hidden
    color: '#B5C200',
  },
  AIR_DELIVERY: {
    label: 'AIR_DELIVERY',
    value: ['air_delivery_arranged'],
    color: '#6E9E5C',
  },
  CUSTOMS: {label: 'CUSTOMS', value: ['customs'], color: '#0C7345'},
  TRANSFERRED_TO_LOCAL_CARRIER: {
    label: 'TRANSFERRED_TO_LOCAL_CARRIER',
    value: ['transferred'],
    color: '#003A96',
  },
  DELIVERY_STATUS: {label: 'DELIVERY_STATUS', value: ['delivery_status'], color: '#1E2A3B'},
}

const A1_TABS = {
  ORIGIN: {
    NEW: {LABEL: 'NEW', VALUE: 'new'},
    PICKED_UP: {LABEL: 'PICKED_UP', VALUE: 'picked_up'},
    AWAITING_PICKUP: {label: 'AWAITING_PICKUP', value: 'awaiting_pickup'},
    SHIPPED: {label: 'SHIPPED', value: 'shipped'},
    CANCELLED: {label: 'CANCELLED', value: 'cancelled'},
  },
  DESTINATION: {
    NEW: {label: 'NEW', value: 'new'},
    READY_FOR_DROP_OFF: {label: 'READY_FOR_DROP_OFF', value: 'ready_for_drop_off'},
    TRANSFERRED: {label: 'TRANSFERRED', value: 'transferred'},
  },
}

const AIRPORT_CODES = [
  {label: 'SZX', value: 'SZX'},
  {label: 'PEK', value: 'PEK'},
  {label: 'SHA', value: 'SHA'},
  {label: 'HAN (Vietnam)', value: 'HAN'},
  {label: 'LAX', value: 'LAX'},
  {label: 'ORD', value: 'ORD'},
  {label: 'JFK', value: 'JFK'},
  {label: 'ATL', value: 'ATL'},
]

const OPTIONS_A1_SERVICE = {
  ALL_IN_ONE: {
    label: 'A1_ALL_IN_ONE',
    value: 'all_in_one',
  },
  CUSTOMIZE: {
    label: 'CUSTOMIZE',
    value: 'customize',
    isDisabled: true,
  },
}

const OPTIONS_CONTENT_TYPE = [
  {label: 'MERCHANDISE', value: 'merchandise'},
  {label: 'GIFT', value: 'gift'},
  {label: 'DOCUMENTS', value: 'documents'},
  {label: 'SAMPLE', value: 'sample'},
  {label: 'RETURN', value: 'return'},
  {label: 'HUMANITARIAN', value: 'humanitarian'},
  {label: 'DANGEROUS_GOODS', value: 'dangerousgoods'},
  {label: 'OTHER', value: 'other'},
]

const PARAMS_A1_BATCHES_FILTER = [
  'date_from',
  'date_to',
  'name',
  'code',
  'journey_info',
  'journey_status',
  'origin_airport',
  'destination_airport',
  'shipper_name',
]

const PARAMS_A1_BATCHES_DETAIL_TABLE_FILTER = [
  'search_text',
  'date_from',
  'date_to',
  'order_date',
  'container_id',
  'content',
  'hts_code',
  'country_of_origin',
  'release_status',
  'customer',
  'order_ref',
  'item_sku',
  'item_name',
  'service',
  'package_info',
]

const UNIT_VALUES = {
  WEIGHT_CARRIER: {
    oz: {max: 1120},
    lb: {max: 70},
    gm: {max: 31751},
    kg: {max: 31.5},
  },
  WEIGHT: {
    oz: {max: 10000},
    lb: {max: 625},
    gm: {max: 283495},
    kg: {max: 283.5},
  },
  DIMENSION: {
    in: {max: 100},
    cm: {max: 254},
    mm: {max: 2540},
  },
}

const MAX_LAYOVER = 5
const MAX_ADDITIONAL_CHARGE = 6

const SORT_KEYS_ORIGIN_VALIDATE = [
  'origin',
  'layover',
  'destination',
  'mawb',
  'shipment_detail',
  'charges',
]

const OPTIONS_RELEASE_STATUS = {
  HOLD: {label: 'HOLD', value: 'hold'},
  REJECTED: {label: 'REJECTED', value: 'rejected'},
  INFORMAL_RELEASED: {label: 'INFORMAL_RELEASED', value: 'informal_released'},
  FORMAL_RELEASED: {label: 'FORMAL_RELEASED', value: 'formal_released'},
  MANUAL_RELEASED: {label: 'MANUAL_RELEASED', value: 'manual_released'},
  DESTROYED: {label: 'DESTROYED', value: 'destroyed'},
}

const MASS_UPDATE = {
  RELEASE_STATUS: {label: 'RELEASE_STATUS', value: 'release_status'},
}

const OPTION_PACKAGE_TYPE = {
  INPUT_DIMENSION: {label: 'INPUT_DIMENSION', value: 'input_dimension'},
  CUSTOM_PACKAGE: {label: 'CUSTOM_PACKAGE', value: 'custom_package'},
  CARRIER_STANDARD_PACKAGE: {label: 'CARRIER_STANDARD_PACKAGE', value: 'carrier_standard_package'},
}

const OPTION_DIMENSION_UNIT = [
  {label: 'in', value: 'in'},
  {label: 'cm', value: 'cm'},
  {label: 'mm', value: 'mm'},
]

const OPTION_WEIGHT_UNIT = [
  {label: 'oz', value: 'oz'},
  {label: 'lb', value: 'lb'},
  {label: 'gm', value: 'gm'},
  {label: 'kg', value: 'kg'},
]

const ORDER_STATUS = {
  OPEN: 'open',
  SHIPPED: 'shipped',
  AWAITING_PAYMENT: 'awaiting_payment',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
  ERROR: 'error',
}

const DOCUMENT_TYPE = {
  T86_DOCUMENTS: {label: 'T86_DOCUMENTS', value: 't86_documents'},
}

const FLIGHT_INFO_TYPE = {
  DEPARTURE: 'Departure',
  DESTINATION: 'Destination',
}

const TICKET_STATUS = {
  ALL: {label: 'ALL', value: ''},
  OPEN: {label: 'OPEN', value: 'open'},
  RESOLVED: {label: 'CLOSED', value: 'resolved'},
}

const PARAMS_TICKET_FILTER = [
  'modal',
  'id',
  's',
  'status',
  'recipient',
  'date_ticket_from',
  'date_ticket_to',
]

const BATCHES_CONFIG = {
  COUNT_CREATE_ALL_LABELS: 10,
  COUNT_PRINT_ALL_LABELS: 500,
  PAGE_SIZE_LOAD_MORE: 200,
  MAX_UPLOAD: 5000,
  SUPPORTED_FORMATS: ['text/csv'],
}

// Column mapping catalog for "Map Your CSV To ShipBae" - the 43 fields accepted by
// /batches/mapping (src/docs/partner-batch-mapping-api-fe.md, section 3).
// `header` is the exact label the Create A1 Batch upload expects, copied verbatim from
// public/media/gori/a1/A1_Batch_Upload_Template.csv (asterisks included) - a single wrong
// character makes the backend reject the whole file.
// `aliases` are normalized template headers that differ from the field key, used by Map by Column Name.
const A1_BATCH_UPLOAD_MAPPING = {
  DEFAULT: [
    {label: 'DO_NOT_MAP', value: '', header: '', required: false},
    {label: 'ORDER_GROUP', value: 'order_group', header: 'Order Group*', required: true},
    {label: 'TO_COMPANY', value: 'to_company', header: 'To Company*', required: true},
    {
      label: 'RESIDENTIAL',
      value: 'residential',
      header: 'Is Residential (Y/N)',
      required: false,
      aliases: ['is_residential_(y/n)', 'is_residential'],
    },
    {label: 'TO_FIRST_NAME', value: 'to_first_name', header: 'To First Name*', required: true},
    {label: 'TO_LAST_NAME', value: 'to_last_name', header: 'To Last Name', required: false},
    {
      label: 'TO_PHONE_NUMBER',
      value: 'to_phone_number',
      header: 'To Phone Number',
      required: false,
    },
    {
      label: 'TO_EMAIL_ADDRESS',
      value: 'to_email_address',
      header: 'To Email Address',
      required: false,
    },
    {label: 'TO_STREET_1', value: 'to_street_1', header: 'To Street 1*', required: true},
    {label: 'TO_STREET_2', value: 'to_street_2', header: 'To Street 2', required: false},
    {label: 'TO_CITY', value: 'to_city', header: 'To City*', required: true},
    {label: 'TO_STATE', value: 'to_state', header: 'To State*', required: true},
    {label: 'TO_ZIP', value: 'to_zip', header: 'To Zip*', required: true},
    {label: 'TO_COUNTRY', value: 'to_country', header: 'To Country*', required: true},
    {label: 'FROM_COMPANY', value: 'from_company', header: 'From Company*', required: true},
    {
      label: 'FROM_FIRST_NAME',
      value: 'from_first_name',
      header: 'From First Name*',
      required: true,
    },
    {label: 'FROM_LAST_NAME', value: 'from_last_name', header: 'From Last Name', required: false},
    {
      label: 'FROM_PHONE_NUMBER',
      value: 'from_phone_number',
      header: 'From Phone Number',
      required: false,
    },
    {
      label: 'FROM_EMAIL_ADDRESS',
      value: 'from_email_address',
      header: 'From Email Address',
      required: false,
    },
    {label: 'FROM_STREET_1', value: 'from_street_1', header: 'From Street 1*', required: true},
    {label: 'FROM_STREET_2', value: 'from_street_2', header: 'From Street 2', required: false},
    {label: 'FROM_CITY', value: 'from_city', header: 'From City*', required: true},
    {label: 'FROM_STATE', value: 'from_state', header: 'From State*', required: true},
    {label: 'FROM_ZIP', value: 'from_zip', header: 'From Zip*', required: true},
    {label: 'FROM_COUNTRY', value: 'from_country', header: 'From Country*', required: true},
    {label: 'ITEM_SKU', value: 'item_sku', header: 'Item SKU', required: false},
    {label: 'ITEM_NAME', value: 'item_name', header: 'Item Name*', required: true},
    {label: 'ITEM_QUANTITY', value: 'item_quantity', header: 'Item Quantity*', required: true},
    {
      label: 'ITEM_PRICE',
      value: 'item_price',
      header: 'Item Price ($)*',
      required: true,
      aliases: ['item_price_($)'],
    },
    {label: 'ITEM_CONTENT', value: 'item_content', header: 'Item Content*', required: true},
    {
      label: 'ITEM_DESCRIPTION',
      value: 'item_description',
      header: 'Item Description*',
      required: true,
    },
    {
      label: 'ITEM_HTS',
      value: 'item_hts',
      header: 'Item HTS Code*',
      required: true,
      aliases: ['item_hts_code'],
    },
    {label: 'ITEM_WEIGHT', value: 'item_weight', header: 'Item Weight*', required: true},
    {
      label: 'ITEM_WEIGHT_UNIT',
      value: 'item_weight_unit',
      header: 'Item Weight Unit*',
      required: true,
    },
    {
      label: 'ITEM_COUNTRY_OF_ORIGIN',
      value: 'item_country_of_origin',
      header: 'Item Country of Origin*',
      required: true,
    },
    {
      label: 'SHIPPING_SERVICE',
      value: 'shipping_service',
      header: 'Shipping Service*',
      required: true,
    },
    {
      label: 'SHIPMENT_PACKAGE_TYPE',
      value: 'shipment_package_type',
      header: 'Shipment Package Type',
      required: false,
    },
    {
      label: 'SHIPMENT_LENGTH',
      value: 'shipment_length',
      header: 'Shipment Length*',
      required: true,
    },
    {label: 'SHIPMENT_WIDTH', value: 'shipment_width', header: 'Shipment Width*', required: true},
    {
      label: 'SHIPMENT_HEIGHT',
      value: 'shipment_height',
      header: 'Shipment Height*',
      required: true,
    },
    {
      label: 'SHIPMENT_DIM_UNIT',
      value: 'shipment_dimension_unit',
      header: 'Shipment Dim Unit*',
      required: true,
      aliases: ['shipment_dim_unit'],
    },
    {
      label: 'ORDER_REFERENCE_1',
      value: 'order_reference_1',
      header: 'Order Reference 1',
      required: false,
    },
    {
      label: 'ORDER_REFERENCE_2',
      value: 'order_reference_2',
      header: 'Order Reference 2',
      required: false,
    },
    {label: 'CONTAINER_ID', value: 'container_id', header: 'Container ID', required: false},
  ],
}

export const A1_CONSTANTS = {
  UPLOAD_CONFIG,
  A1_BATCH_UPLOAD_MAPPING,
  STATUS_ADD_TO_A1_BATCH,
  A1_BATCH_STATUS,
  OPTIONS_JOURNEY_INFO,
  OPTIONS_JOURNEY_STATUS,
  A1_TABS,
  AIRPORT_CODES,
  OPTIONS_A1_SERVICE,
  OPTIONS_CONTENT_TYPE,
  PARAMS_A1_BATCHES_FILTER,
  PARAMS_A1_BATCHES_DETAIL_TABLE_FILTER,
  UNIT_VALUES,
  MAX_LAYOVER,
  MAX_ADDITIONAL_CHARGE,
  SORT_KEYS_ORIGIN_VALIDATE,
  OPTIONS_RELEASE_STATUS,
  MASS_UPDATE,
  OPTION_PACKAGE_TYPE,
  OPTION_DIMENSION_UNIT,
  OPTION_WEIGHT_UNIT,
  ORDER_STATUS,
  DOCUMENT_TYPE,
  TICKET_STATUS,
  PARAMS_TICKET_FILTER,
  FLIGHT_INFO_TYPE,
  BATCHES_CONFIG,
}
